import { IconEllipsisHorizontal } from "@/assets/icons/geist/IconEllipsisHorizontal";
import { Button } from "@/components/flexkit/Button";
import type React from "react";
import { type FC, type PropsWithChildren } from "react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger } from "./DropDown";
import { cn } from "@/components/podkit/lib/cn";

const buttonClassName = cn(
    "flex rounded-md bg-transparent p-1 hover:bg-surface-hover data-[state=open]:bg-surface-hover",
);

export const DropdownActions: FC<
    {
        button?: React.ReactNode;
        triggerTestId?: string;
        open?: boolean;
        onOpenChange?: (open: boolean) => void;
        align?: "start" | "end";
    } & PropsWithChildren
> = ({ button, children, triggerTestId, open, onOpenChange, align = "end" }) => {
    return (
        <DropdownMenu open={open} onOpenChange={onOpenChange}>
            {/* Todo: finally move the styles out of index.css */}
            <DropdownMenuTrigger className={buttonClassName} data-testid={triggerTestId} asChild>
                {button ? (
                    button
                ) : (
                    <Button variant="ghost" className={buttonClassName} aria-label="More actions">
                        <IconEllipsisHorizontal size="base" className="size-6 rounded-md p-0.5 text-content-primary" />
                    </Button>
                )}
            </DropdownMenuTrigger>
            <DropdownMenuContent align={align} className="focus-visible:ring-0">
                {children}
            </DropdownMenuContent>
        </DropdownMenu>
    );
};
